// Глобальный перехват аппаратной кнопки «Назад» (Android / браузер) для SPA.
// Открытые экраны/окна регистрируют обработчик; нажатие «Назад» закрывает верхний из них.
import { useEffect, useRef } from 'react';

const handlers = [];

export const registerBackHandler = (fn) => {
  handlers.push(fn);
  return () => {
    const i = handlers.indexOf(fn);
    if (i >= 0) handlers.splice(i, 1);
  };
};

// Вызывает обработчики от верхнего (последнего открытого) к нижнему.
// Возвращает true, если нажатие «Назад» было обработано (что-то закрылось).
export const handleBackPress = () => {
  for (let i = handlers.length - 1; i >= 0; i--) {
    if (handlers[i]()) return true;
  }
  return false;
};

// Хук: пока isOpen=true, кнопка «Назад» вызывает closeFn вместо выхода из приложения
export const useBackClose = (isOpen, closeFn) => {
  const closeRef = useRef(closeFn);
  closeRef.current = closeFn;

  useEffect(() => {
    if (!isOpen) return undefined;
    return registerBackHandler(() => {
      closeRef.current();
      return true;
    });
  }, [isOpen]);
};
